// src/app/analytics/properties.ts
export const PROPERTIES = {
  USER_ID: 'userId',
  ROLE: 'role',
  IS_EXTERNAL: 'isExternal',
  ACTION: 'action',
  METHOD: 'method',
  PAGE_NAME: '[Amplitude] Page Title',
  REFERRER: 'referrer',
  TIMESTAMP: 'timestamp',
  SESSION_ID: 'sessionId',
  DEVICE_TYPE: 'deviceType',
  BROWSER: 'browser',
  BROWSER_VERSION: 'browserVersion',
  OS: 'os',
  FEATURE_NAME: 'featureName',
  FILTER_TYPE: 'filterType',
  FILTER_VALUE: 'filterValue',
  ALERT_TYPE: 'alertType',
  MESSAGE: 'message',
  STACK_TRACE: 'stackTrace',
  LOCATION: 'location',
  LOAD_TIME: 'loadTime',
  NETWORK_STATUS: 'networkStatus',
  VESSEL_GROUP_ID: 'VesselGroupID',
  VESSEL_ID: 'VesselID',
  VESSEL_NAME: 'VesselName',
  VESSEL_STATUS: 'VesselStatus',
  VESSEL_TYPE: 'VesselType',
  VESSEL_TYPE_ID: 'VesselTypeID',
  VESSEL_POOL_ID: 'VesselPoolID',
  IMO_NUMBER: 'ImoNumber',
  REPORT_NAME: 'reportName',
  REPORT_TYPE: 'reportType',
  FROM_DATE: 'fromDate',
  TO_DATE: 'toDate',
  VOYAGE_NUMBER: 'voyageNumber',
  REPORT_SECTIONS: 'reportSections',
  TERMS_ID: 'termsId',
  HIRE_RATE: 'hireRate',
  BUNKER_RATE_GO: 'bunkerRateGO',
  BUNKER_RATE_FO: 'bunkerRateFO',
  CARGO_RATE: 'cargoRate',
  DOWNLOAD_TYPE: 'downloadType',
  REPORTING_YEAR: 'reportingYear',
  REPORT_ID_FROM_ENGINE: 'reportIdFromEngine',
  REPORT_STATUS: 'reportStatus',
  ANNUAL_RATING: 'annualRating',
  CO2_EMISSIONS: 'co2Emissions',
  VERIFIER_NAME: 'verifierName',
  EUA_EXPOSURE: 'euaExposure',
  TOTAL_FUEL_COST: 'totalFuelCost',
  FUEL_EU_PENALTY: 'fuelEuPenalty',
  TOTAL_EXPOSURE: 'totalExposure',
  EXPOSURE_PER_MT_CARGO: 'exposurePerMTCargo',
  USD_EXCHANGE_RATE: 'usdExchnageRate',
  VESSEL_LIST: 'vesselList',
  SELECTED_MONTHS: 'selectedMonths',
  PRINCIPAL_ID: 'principalId',
  PRINCIPAL_NAME: 'principalName',
  DUPLICATE_VESSEL_LEVEL_ID: 'duplicateVesselLevelId',
  IS_VESSEL_GROUP: 'isVesselGroup',
  VESSEL_ID_OR_GROUP_ID: 'vesselIdOrGroupId',
}
